import { OrderedSet } from 'immutable';

export function identifyControls(viewContent: string): OrderedSet<string> {
    const regex = /div data-bind='(.*?):/g;

    let set = OrderedSet<string>().asMutable();

    let m;
    while (m = regex.exec(viewContent))
        set.add(m[1])

    return set;
}